import { render, staticRenderFns } from "./workStandardManage.vue?vue&type=template&id=0a419120"
import script from "./workStandardManage.vue?vue&type=script&lang=js"
export * from "./workStandardManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a419120')) {
      api.createRecord('0a419120', component.options)
    } else {
      api.reload('0a419120', component.options)
    }
    module.hot.accept("./workStandardManage.vue?vue&type=template&id=0a419120", function () {
      api.rerender('0a419120', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/mdm/sws/workStandardManage.vue"
export default component.exports